import axios from 'axios';

import { config } from 'config';

export const getApartmentsData = async (): Promise<any[]> => {
  try {
    const url = `${config.backendUrl}/investment/${config.investmentName}`;
    const response = await axios.get<any[]>(url);
    return response.data || [];
  } catch (err) {
    console.error('[Voxdeveloper API failed]', err);
    return [];
  }
};
